import { render, staticRenderFns } from "./EditMessagesWise.vue?vue&type=template&id=7257a1b2&scoped=true&"
import script from "./EditMessagesWise.vue?vue&type=script&lang=js&"
export * from "./EditMessagesWise.vue?vue&type=script&lang=js&"
import style0 from "./EditMessagesWise.vue?vue&type=style&index=0&id=7257a1b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7257a1b2",
  null
  
)

export default component.exports